export const MAP_TYPE = {
  accurateCodeName: '编码+名称全匹配',
  accurateName: '名称全匹配',
  aiModel: 'AI模型',
  // accurateCode: '精确编码',
  approximateName: '名称模糊匹配',
  manual: '人工',
  customModel: '同义词',
}
